import styled from '@emotion/styled';

export const Content = styled.article`
    position: relative;
    width: 100%;
    min-width: 1260px;
    overflow: hidden;
    background: white;
    color: #1d1d1d;
    font-family: 'Pretendard', sans-serif;
    -webkit-user-select: text;
    user-select: text;
    h1,
    h2,
    h3,
    p {
        margin: 0;
    }
`;
export const BackgroundCanvas = styled.div`
    position: absolute;
    left: calc(50% - 1280px);
    width: 2560px;
    pointer-events: none;
`;
export const Background = styled.div`
    position: absolute;
    width: 2560px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
`;
export const Canvas = styled.div`
    position: relative;
    width: 1260px;
    height: 100%;
    margin: 0 auto;
`;
export const Image = styled.img`
    position: absolute;
    display: block;
    max-width: none;
    pointer-events: none;
`;
// GIF 원본의 가장자리 1px에 남은 세로선을 잘라낸다.
export const Animation = styled(Image)`
    clip-path: inset(0 1px round 15px);
`;
export const Decorations = styled(Image)`
    left: -650px;
    top: 0;
`;
export const Section = styled.section`
    position: absolute;
    width: 1260px;
    pointer-events: none;
`;
export const Copy = styled.p`
    position: absolute;
    margin: 0;
    padding: 0;
    white-space: pre;
    font-weight: 500;
    pointer-events: auto;
    list-style-position: inside;
    li {
        margin: 0;
        padding: 0;
        list-style: disc inside;
    }
    li::marker {
        color: transparent;
    }
    li::before {
        content: '';
        position: absolute;
        left: 0.6em;
        top: 0.5em;
        width: 0.2em;
        height: 0.2em;
        border-radius: 50%;
        background: currentColor;
    }
`;

/**
 * 원문 ∙는 유지하고 기존 폰트의 ·를 시안의 폭과 기준선에 맞춰 그린다.
 * 폭은 Paperlogy 322/900em, Pretendard 552/2048em이며 Paperlogy의 ·는 3/900em 올린다.
 */
export const Separator = styled.span<{
    paperlogy: boolean;
    inkColor: string;
    tracking?: string;
}>`
    display: inline-block;
    position: relative;
    width: ${({ paperlogy }) => (paperlogy ? '0.3577777778em' : '0.26953125em')};
    margin-right: ${({ tracking }) => tracking || 0};
    letter-spacing: normal;
    color: transparent;

    &::after {
        content: '·' / '';
        position: absolute;
        inset: 0;
        color: ${({ inkColor }) => inkColor};
        text-align: center;
        transform: ${({ paperlogy }) => (paperlogy ? 'translateY(-0.0033333333em)' : 'none')};
    }
`;

export const PageLink = styled.a`
    position: absolute;
    display: block;
    color: inherit;
    text-decoration: none;
    border-radius: 81px;
    &:focus-visible {
        outline: 3px solid #00419f;
        outline-offset: 5px;
    }
`;

export const TextList = styled.ol`
    margin: 0;
    padding: 0;
    list-style: none;
`;
